import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import { cn } from './lib/utils';
import { format } from 'date-fns';
import parseISO from 'date-fns/parseISO';

export function DateTime({
  className = '',
  left,
  right,
  value,
  min,
  onChange,
  onFocus,
  onDoubleClick,
  ...etc
}) {
  const convert = useCallback((date) => {
    try {
      return format(
        date instanceof Date ? date : parseISO(date),
        'yyyy-MM-dd\'T\'HH:mm',
      );
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }, []);

  const inputMin = useMemo(() => convert(min), [min, convert]);

  //value
  const [inputValue, setInputValue] = useState(convert(value));
  const onInputChange = useCallback(
    (e) => setInputValue(e.currentTarget.value),
    [setInputValue],
  );
  useEffect(() => setInputValue(convert(value)), [value, setInputValue, convert]);
  useEffect(() => {
    if (inputValue) onChange(new Date(inputValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  //focus
  const onInputFocus = useCallback(
    (e) => {
      e.currentTarget.showPicker();
      if (typeof onFocus == 'function') onFocus(e);
    },
    [onFocus],
  );

  //double click
  const onInputDoubleClick = useCallback(
    (e) => {
      e.currentTarget.showPicker();
      if (typeof onDoubleClick == 'function') onDoubleClick(e);
    },
    [onDoubleClick],
  );

  return (
    <label
      className={cn(
        'ui-date-time',
        'inline-flex flex-row items-center gap-[var(--padding-small)] min-h-[var(--button-height)] px-[var(--padding-small)] rounded-[var(--border-radius-small)]',
        className,
      )}
    >
      {left || null}
      <input
        {...etc}
        className='ui-date-time-input'
        type='datetime-local'
        value={inputValue}
        min={inputMin}
        onChange={onInputChange}
        onFocus={onInputFocus}
        onDoubleClick={onInputDoubleClick}
      />
      {right || null}
    </label>
  );
}
